import React from 'react';
import PageLayout from '../components/PageLayout';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Label } from '../components/ui/label';
import { Mail } from 'lucide-react';

const ContactPage = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    // Form submission logic would go here
    alert('Thank you for your message! We will get back to you soon.');
  };

  return (
    <PageLayout title="Contact">
      <div className="space-y-8 text-slate-600">
        <section>
          <p className="text-lg">
            We'd love to hear from you. Whether you have a question about our app, need support, 
            or want to share feedback, our team is here to help.
          </p>
        </section>

        <div className="grid md:grid-cols-2 gap-12">
          {/* Contact Form */}
          <section>
            <h2 className="font-manrope text-2xl font-bold text-slate-900 mb-6">Send Us a Message</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="space-y-2">
                <Label htmlFor="name">Full Name</Label>
                <Input id="name" placeholder="Your name" required />
              </div>
              <div className="space-y-2">
                <Label htmlFor="email">Email Address</Label>
                <Input id="email" type="email" placeholder="you@example.com" required />
              </div>
              <div className="space-y-2">
                <Label htmlFor="subject">Subject</Label>
                <Input id="subject" placeholder="How can we help?" required />
              </div>
              <div className="space-y-2">
                <Label htmlFor="message">Message</Label>
                <Textarea 
                  id="message" 
                  placeholder="Tell us more about your inquiry..." 
                  rows={5}
                  required 
                />
              </div>
              <Button type="submit" className="w-full bg-emerald-500 hover:bg-emerald-600">
                Send Message
              </Button>
            </form>
          </section>

          {/* Contact Information */}
          <section>
            <h2 className="font-manrope text-2xl font-bold text-slate-900 mb-6">Contact Information</h2>
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-lg bg-emerald-100 flex items-center justify-center flex-shrink-0">
                  <Mail className="h-6 w-6 text-emerald-600" />
                </div>
                <div>
                  <h3 className="font-manrope font-bold text-slate-900 mb-1">Email</h3>
                  <p className="text-sm text-slate-600 mb-1">Support</p>
                  <a href="mailto:support@signalpathdigitalapps.com" className="text-emerald-600">
                    support@signalpathdigitalapps.com
                  </a>
                </div>
              </div>
            </div>

            <div className="mt-8 p-6 bg-slate-100 rounded-xl">
              <h3 className="font-manrope font-bold text-slate-900 mb-2">Response Time</h3>
              <p className="text-sm">
                We strive to respond to all inquiries within 24-48 business hours.
              </p>
            </div>
          </section>
        </div>
      </div>
    </PageLayout>
  );
};

export default ContactPage;
